/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import procedureDivorceSectionStyle from "./procedureDivorceSectionStyle";
import Grid from "@mui/material/Grid";
import Container from "../../../Container/Container";
import TextContainer from "../../../Container/TextContainer";
import IconDocument from "../../../../assets/icons/generic/IconDocument";
import IconDocumentVv from "../../../../assets/icons/serviceOverview/IconDocumentVv";
import IconCourt from "../../../../assets/icons/serviceOverview/IconCourt";
import Typography from "@mui/material/Typography";
import GradientPaper from "../../../GradientComponents/GradientPaper";
import { Box, Theme } from "@mui/material";
import { SxProps } from "@mui/system";
import { useTheme } from "@mui/material/styles";
import IconWrapper from "../../../IconWrapper/IconWrapper";

type ProcedureDivorceSectionProps = {
  headline?: string;
  iconOverwrites?: string[] | React.ComponentType<{ sx?: SxProps<Theme> }>[];
};

const ProcedureDivorceSection = ({ headline = "Der Ablauf einer Scheidung bei Legalbird", iconOverwrites = [] }: ProcedureDivorceSectionProps) => {
  const theme = useTheme();

  return (
    <>
      <Container sx={procedureDivorceSectionStyle.centered}>
        <Box sx={procedureDivorceSectionStyle.scrollToAnchor} id="ablauf">
          {" "}
        </Box>
        <Typography component={"h2"} variant={"h3"}>{headline}</Typography>
      </Container>
      <div>
        <TextContainer sx={procedureDivorceSectionStyle.centered}>
          <Grid container>
            <Grid size={12}>
              <GradientPaper sx={procedureDivorceSectionStyle.paper}>
                <Grid container sx={procedureDivorceSectionStyle.gridContainer}>
                  <Grid
                    size={{
                      xs: 12,
                      sm: 4
                    }}>
                    <GetIconComponent iconOverwrites={iconOverwrites[0]} defaultIcon={IconDocument} sx={procedureDivorceSectionStyle.icon(theme)} />
                  </Grid>
                  <Grid
                    size={{
                      xs: 12,
                      sm: 8
                    }}>
                    <Typography component={"h3"} variant={"h5"}>1. Scheidungsformular</Typography>
                    <Typography variant={"body2"}>Sie füllen innerhalb von 5 Minuten online das Formular aus</Typography>
                  </Grid>
                </Grid>
                <Grid container sx={procedureDivorceSectionStyle.gridContainer}>
                  <Grid
                    size={{
                      xs: 12,
                      sm: 8
                    }}>
                    <Typography component={"h3"} variant={"h5"}>2. Scheidungsantrag</Typography>
                    <Typography variant={"body2"}>Wir erstellen den Antrag für Sie und reichen ihn bei Gericht ein</Typography>
                  </Grid>
                  <Grid
                    sx={procedureDivorceSectionStyle.gridItemReversed}
                    size={{
                      xs: 12,
                      sm: 4
                    }}>
                    <GetIconComponent iconOverwrites={iconOverwrites[1]} defaultIcon={IconDocumentVv} sx={procedureDivorceSectionStyle.icon(theme)} />
                  </Grid>
                </Grid>
                <Grid container sx={procedureDivorceSectionStyle.gridContainer}>
                  <Grid
                    size={{
                      xs: 12,
                      sm: 4
                    }}>
                    <GetIconComponent iconOverwrites={iconOverwrites[2]} defaultIcon={IconCourt} sx={procedureDivorceSectionStyle.icon(theme)} />
                  </Grid>
                  <Grid
                    size={{
                      xs: 12,
                      sm: 8
                    }}>
                    <Typography component={"h3"} variant={"h5"}>3. Scheidungstermin</Typography>
                    <Typography variant={"body2"}>Das Gericht weist Ihnen einen Scheidungstermin zu und Sie werden geschieden</Typography>
                  </Grid>
                </Grid>
                <Typography component={"h4"} variant={"h5"} sx={procedureDivorceSectionStyle.questions}>
                  Sie haben Fragen?
                </Typography>
                <Typography variant={"body2"}>
                  Nach Ihrer Registrierung rufen wir Sie zeitnah an, um alle offenen Fragen zu klären und wir beraten Sie persönlich zu Ihrer Scheidung!
                </Typography>
              </GradientPaper>
            </Grid>
          </Grid>
        </TextContainer>
      </div>
    </>
  );
};

const GetIconComponent = ({
  defaultIcon,
  sx = {},
  iconOverwrites,
}: {
  defaultIcon: string | React.ComponentType<{ sx?: SxProps<Theme> }>;
  sx?: SxProps;
  iconOverwrites?: string | React.ComponentType<{ sx?: SxProps<Theme> }>;
}) => {
  const IconComponent = iconOverwrites ? iconOverwrites : defaultIcon;
  return <IconWrapper icon={IconComponent} sx={sx} />
};

export default ProcedureDivorceSection;
